export type FigureKind = 'headcount' | 'fte';

const MAX_FTE_FRACTION_DIGITS = 2;

export function sanitizeFigureText(text: string, kind: FigureKind): string {
  if (kind === 'headcount') {
    return text.replace(/\D/g, '');
  }
  const normalized = text.replace(/,/g, '.').replace(/[^\d.]/g, '');
  const [integerPart, ...fractionParts] = normalized.split('.');
  if (fractionParts.length === 0) {
    return integerPart;
  }
  return `${integerPart}.${fractionParts.join('').slice(0, MAX_FTE_FRACTION_DIGITS)}`;
}

export function parseFigure(text: string): number | null {
  if (text === '' || text === '.') {
    return null;
  }
  const parsed = Number(text);
  return Number.isNaN(parsed) ? null : parsed;
}
